<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Audit') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">
      
      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">
        
        <template slot="content">
          <table class="table">
            <thead>
              <tr>
                <th colspan="2">{{ $t('Author') }}</th>
                <th>{{ $t('Message') }}</th>
                <th>{{ $t('Date') }}</th>
              </tr>
            </thead>
            <tbody>
              <AuditItem
                v-for="(item, index) in audits"
                :key="index"  
                :value="item" />
            </tbody>
          </table>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

    </div>

  </div>

</template>

<script>
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'
import AuditItem from './AuditItem'

export default {
  name: 'Audit',
  components: {
    ThSort,
    Paginaty,
    AuditItem
  },
  data () {
    return {
      creating: true,
      loading: true,
      filters: {},
      sort: '-created_at'
    }
  },
  computed: {
    audits () {
      return this.$store.getters.getAudits
    },
    paginate () {
      return this.$store.getters.getAuditsPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectAudits', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Audit/Audit.vue